import type { SetupProgress } from "../registry/types";

export interface StartGuideResetOptions {
  resetDismissed: boolean;
  resetIntake: boolean;
  resetDeferred: boolean;
}

export function getStartGuideResetOptions({
  existingRow,
  forceResetIntake,
}: {
  existingRow: SetupProgress | null;
  forceResetIntake: boolean;
}): StartGuideResetOptions {
  return {
    resetDismissed: forceResetIntake || existingRow?.dismissedAt != null,
    resetIntake: forceResetIntake || existingRow?.intakeCompletedAt != null,
    resetDeferred: forceResetIntake || existingRow?.deferredUntil != null,
  };
}
